var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"not-found mt-5 pt-5 text-center"},[_c('div',{staticClass:"text-bold text-primary h1"},[_vm._v("Page introuvable")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Retour à l'accueil")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }